import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { MicIconBig } from '../assets/MicIconBig';
import { blueEnabledColor, lightGrey, white, controlsBlueHover, mediumBlue, controlsDisabled } from '../styles/colors';
import { withMicrophoneMeter } from '../utils/withMicrophoneMeter';

/**
 * SpeechButtonSimple is the microphone button and the volume level display, together.
 * It will know its own size based on buttonSize prop and whether there is speakText prop
 * SpeechButtonSimple is simplified version of SpeechButton and is based on new designs for gaia-web Vocab activity.
 *   main differences are: no text support, bigger speaker icon, new colors and new animation based on icon border stroke.
 */

var SpeechButtonDiv = styled.div(function (props) {
  var style = {
    position: 'relative',
    width: props.buttonSize,
    height: props.buttonSize,
    cursor: 'pointer'
  };
  if (props.disabled) {
    style.pointerEvents = 'none';
  }
  return style;
});

var MicLevelPositioner = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: props.buttonSize,
    height: props.buttonSize,
    zIndex: 2,
    borderColor: mediumBlue,
    borderStyle: 'solid',
    boxSizing: 'border-box',
    borderWidth: 0,
    borderRadius: props.buttonSize,
    transition: 'border-width'
  };
  if (props.isListening) {
    if (props.soundLevel < 0.33) {
      style.borderWidth = 1;
    } else if (props.soundLevel > 0.66) {
      style.borderWidth = 4;
    } else {
      style.borderWidth = 2;
    }
  }

  return style;
});

var MicIconDiv = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: props.buttonSize,
    height: props.buttonSize,
    zIndex: 1
  };

  return style;
});

//***************************************************************************************

var SpeechButtonSimpleBase = function (_PureComponent) {
  _inherits(SpeechButtonSimpleBase, _PureComponent);

  function SpeechButtonSimpleBase() {
    _classCallCheck(this, SpeechButtonSimpleBase);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  SpeechButtonSimpleBase.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) {
      this.props.onUnmount();
    }
  };

  SpeechButtonSimpleBase.prototype.render = function render() {
    var iconDisp = void 0;
    if (this.props.isListening) {
      iconDisp = React.createElement(MicIconBig, { circleColor: controlsBlueHover, iconColor: mediumBlue });
    } else {
      if (this.props.disabled) {
        iconDisp = React.createElement(MicIconBig, { circleColor: white, iconColor: controlsDisabled });
      } else {
        // not recording/listening, enabled
        iconDisp = React.createElement(MicIconBig, { circleColor: white, iconColor: mediumBlue });
      }
    }

    return React.createElement(
      SpeechButtonDiv,
      {
        'data-qa': 'SpeechButton',
        onClick: this.props.onClick,
        buttonSize: this.props.buttonSize,
        disabled: this.props.disabled || this.props.isListening && !this.props.isStoppable
      },
      React.createElement(MicLevelPositioner, {
        buttonSize: this.props.buttonSize,
        isListening: this.props.isListening,
        soundLevel: this.props.soundLevel
      }),
      React.createElement(
        MicIconDiv,
        { buttonSize: this.props.buttonSize },
        iconDisp
      )
    );
  };

  return SpeechButtonSimpleBase;
}(PureComponent);

SpeechButtonSimpleBase.propTypes = {
  buttonSize: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  onUnmount: PropTypes.func,
  onClick: PropTypes.func.isRequired,
  isListening: PropTypes.bool.isRequired,
  isStoppable: PropTypes.bool.isRequired
};


export var SpeechButtonSimple = withMicrophoneMeter(SpeechButtonSimpleBase);